import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

type LanguageSwitcherProps = {
  compact?: boolean;
  className?: string;
};

export function LanguageSwitcher({ compact = false, className }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.resolvedLanguage === "es" ? "es" : "en";

  const setLanguage = (next: "en" | "es") => {
    void i18n.changeLanguage(next);
  };

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full border border-border bg-card p-1",
        compact ? "gap-1" : "gap-1.5",
        className,
      )}
      aria-label={t("language.label")}
    >
      {(["en", "es"] as const).map((lang) => {
        const isActive = currentLanguage === lang;
        return (
          <button
            key={lang}
            type="button"
            onClick={() => setLanguage(lang)}
            className={cn(
              "rounded-full px-2.5 py-1 text-xs font-semibold uppercase tracking-wide transition-colors",
              isActive
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:bg-secondary hover:text-foreground",
            )}
          >
            {lang}
          </button>
        );
      })}
    </div>
  );
}
